/* eslint-disable react/require-default-props */
import type { RefObject } from 'react';
import { Button } from 'components/deprecated/Button';
import fscreen from 'fscreen';
import { IconCloseSquare } from 'components/Icons/IconCloseSquare';
import { IconFull } from 'components/Icons/IconFull';
import { IO } from 'fp-ts/lib/IO';
import { cx } from '@linaria/core';
import { IconInfo } from 'components/Icons';
import { baseTheme } from 'styles/utils';
import { TextTooltip } from 'components/Tooltip';
import { iconTooltip } from 'modules/InputViewer/components/ActionPanel/ActionPanel.styles';
import { button, inputInfoButton } from './InputActionBar.styles';

interface ActionButtonsProps {
  onClose: IO<void>;
  className?: string;
}

interface FSProps {
  fullscreenRef: RefObject<HTMLDivElement>;
  className?: string;
}

export const CloseButton = ({ onClose, className }: ActionButtonsProps): JSX.Element => {
  return (
    <Button kind="secondary" data-testid="close-button" onClick={onClose} className={cx(button, className)}>
      <IconCloseSquare size={18} color={baseTheme.light.colors.black} />
    </Button>
  );
};

export const FullScreenButton_Deprecated = ({ fullscreenRef, className }: FSProps): JSX.Element => {
  const onFullScreen: IO<void> = () => {
    if (fscreen.fullscreenEnabled && fscreen.fullscreenElement === null) {
      fscreen.requestFullscreen(fullscreenRef.current as Element);
    } else if (fscreen.fullscreenElement !== null) {
      fscreen.exitFullscreen();
    }
  };

  return (
    <Button kind="secondary" data-testid="fullscreen-button" onClick={onFullScreen} className={cx(button, className)}>
      <IconFull size={18} color={baseTheme.light.colors.black} />
    </Button>
  );
};

// TODO: Implement expended state of button
export const InputInfoButton = (): JSX.Element => {
  return (
    <TextTooltip text="View Input Details" className={iconTooltip}>
      <Button kind="secondary" data-testid="input-info-button" className={inputInfoButton}>
        <IconInfo size={18} color={baseTheme.light.colors.black} />
      </Button>
    </TextTooltip>
  );
};

// export const FullScreenButton = ({ toggle, className }: { className?:string; toggle: () => void }): JSX.Element => {
//   return (
//     <Button kind="secondary" data-testid="fullscreen-button" onClick={toggle} className={cx(button, className)}>
//       <IconFull size={18} color={baseTheme.light.colors.black} />
//     </Button>
//   );
// };

export const inputBarActions = {
  CloseButton,
  FullScreenButton_Deprecated,
  InputInfoButton,
  // FullScreenButton,
};
